(function ($) {
  // Initialize functions
  closeTopBar();

  // Existing scroll event for sticky header
  window.addEventListener('scroll', function () {
    var header = document.getElementById('site-header');
    var scrollDistance = window.scrollY;

    if (scrollDistance > 0) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  });

  // Function to initialize mobile menu and submenu toggles
  function initMobileMenu() {
    if (window.innerWidth < 768) {
      var menuItemsWithSubmenu = document.querySelectorAll('#conference-2025-header .nav__menu-item--has-submenu > a');

      menuItemsWithSubmenu.forEach(function (menuItem) {
        menuItem.addEventListener('click', function (e) {
          e.preventDefault(); // Prevent default link behavior

          // Toggle the visibility of the submenu
          var submenu = this.nextElementSibling;
          if (submenu.classList.contains('sub-menu')) {
            submenu.classList.toggle('is-active');
          }

          // Toggle "active" class on the parent menu item
          var parentMenuItem = this.parentElement;
          parentMenuItem.classList.toggle('is-active');

          // Optionally close other open submenus and remove active class from other items
          menuItemsWithSubmenu.forEach(function (otherMenuItem) {
            var otherSubmenu = otherMenuItem.nextElementSibling;
            var otherParentMenuItem = otherMenuItem.parentElement;

            if (otherSubmenu !== submenu && otherSubmenu.classList.contains('is-active')) {
              otherSubmenu.classList.remove('is-active');
              otherParentMenuItem.classList.remove('is-active');
            }
          });
        });
      });
    }
  }

  function closeTopBar() {
    var closeTopBarBtn = document.getElementById('closeTopBar');
    var topBar = $('.conference-header__top-bar');

    if (closeTopBarBtn) {
      closeTopBarBtn.addEventListener('click', function () {
        // topBar.style.display = 'none';
        topBar.slideUp(200, function () {
          adjustContentTop();
        });
      });
    }
  }

  // Adjust content padding based on header height
  function adjustContentTop() {
    var header = document.querySelector('.conference-header');
    var content = document.querySelector('.conference-content');
    content.style.paddingTop = header.offsetHeight + 'px';
  }

  function tealium() {
    $(document).on('mousedown', 'a', (e) => {
      // bail if utag has been ad-blocked
      if (typeof window.utag === 'object' && typeof window.utag.link === 'function') {
        // find the current link from the event delegation
        const link = $(e.currentTarget);
        // see if any parent nodes have tealium data
        const closestTealium = link.closest('[data-tealium]');
        // list of fields to grab from utag_data from the customer profile
        const profileFields = ['customer_type', 'customer_status', 'customer_id_login', 'customer_id', 'customer_email_address', 'customer_category'];

        // initialize our data object with some defaults
        let data = {
          event_name: 'click',
          event_action: 'click'
        };

        // return if link is part of the WordPress Toolbar
        if (link.parents('#wpadminbar').length > 0) return false;

        //if (link.attr('data-event-category') || link.attr('data-event-action') || link.attr('data-event-label')) return false;

        // slug the text of the link to normalize text differences for the event_label_description
        data.event_label_description = slugify((link.attr('data-event-label')) ? link.attr('data-event-label') : (link.attr('title')) ? link.attr('title') : link.text(), { lower: true });

        // if there is no text but an image in the link - use the filename of the image as the event_label_description
        if (!data.event_label_description && link.find('img').length) {
          data.event_label_description = (link.attr('title')) ? link.attr('title') : link.find('img').first().attr('src').split('/').pop();
        }

        // check if click event is pagination and provide readable label
        if (link.hasClass('page-numbers')) {
          if (link.hasClass('next') || link.hasClass('prev')) {
            data.event_label_description = slugify('page_' + $('.visually-hidden', link).text(), { lower: true });
          } else {
            data.event_label_description = 'page_' + link.text();
          }
        }

        if (typeof window.utag_data !== 'undefined' && window.utag_data.customer_status && window.utag_data.customer_status !== 'false') {
          // if users are logged in, copy their utag_data values
          profileFields.forEach((key) => {
            if (typeof window.utag_data[key] !== 'undefined') {
              data[key] = window.utag_data[key];
            }
          });
        } else {
          // not logged in
          data.customer_status = '0';
        }

        // if there is tealium data on a post element or layout - grab it and set the value of event_category_campaign
        if (link.attr('data-event-category')) {
          data.event_category_campaign = link.attr('data-event-category');
        } else if (closestTealium.length) {
          data.event_category_campaign = closestTealium.first().attr('data-tealium');
        } else if (window.utag_data.event_category_campaign) {
          data.event_category_campaign = window.utag_data.event_category_campaign;
        }

        // if the event action is defined on the post element - grab it and set the value of event_action
        if (link.attr('data-event-action')) {
          data.event_action = link.attr('data-event-action');
        }

        // if there are any campaigns, change the action to campaign click
        if (data.event_category_campaign && data.event_category_campaign.length > 0 && !link.attr('data-event-action')) {
          data.event_action = 'campaign_click';
        }

        // log the data);
        if (document.body.classList.contains('logged-in')) {
          console.log(data);
        }

        window.utag.link(data);
      }
    });
  }

  function slugify(str) {
    return str
      .toString()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // remove accents
      .toLowerCase()
      .trim()
      .replace(/[\s\W-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Initialize the mobile menu on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    var hamburger = document.querySelector('.hamburger');
    var navbar = document.querySelector('.navbar');

    adjustContentTop();
    tealium();

    // Hamburger menu toggle
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('is-active');
      navbar.classList.toggle('is-active');
    });

    // Call mobile menu init
    initMobileMenu();
  });

  // Re-check and reinitialize on window resize
  window.addEventListener('resize', function () {
    initMobileMenu();
  });

})(jQuery);